(function (window) {
  'use strict';

  var SUBSTEPS = ['none', 'store_chosen', 'docs_uploaded'];
  var REFUSED_SLUGS = ['demande_refusee', 'proposition_refusee'];

  // Codes ERP réels (5) + alias UI normalisés (PRO, NON_PART). 'PART' = particulier ;
  // tout le reste mappe vers 'NON_PART' (loueur, fabricant, LLD, LOU).
  var KNOWN_VENDOR_TYPES = ['PART', 'VEL', 'LOU', 'LLD', 'FAB', 'PRO', 'NON_PART'];

  function ContractualisationSubstep(reprise, vendorType) {
    this.reprise = reprise || {};
    this.repriseId = this.reprise.id || null;
    if (vendorType !== undefined && vendorType !== null && KNOWN_VENDOR_TYPES.indexOf(vendorType) === -1) {
      try {
        console.warn('[buyback] vendorType inattendu, fallback NON_PART :', vendorType);
      } catch (e) {}
    }
    // PART/null → PART ; tout le reste (VEL/LOU/LLD/FAB/PRO/NON_PART/inconnu) → NON_PART.
    this.vendorType = vendorType === 'PART' || vendorType == null ? 'PART' : 'NON_PART';
  }

  ContractualisationSubstep.prototype.compute = function () {
    var r = this.reprise;
    var id = this.repriseId;
    var docs = r.docs || {};

    if (r.status_slug && REFUSED_SLUGS.indexOf(r.status_slug) !== -1) {
      return 'none';
    }

    var isNonPart = this.vendorType === 'NON_PART';
    var hasStoreOrPickup = false;
    try {
      if (isNonPart) {
        // NON-PART : pickup_requested_date n'est PAS sérialisé dans le payload
        // liste (cf list-actions.js qui doit refetch detail pour l'obtenir).
        // Fallback : marker session posé au moment du persist depuis le portail.
        hasStoreOrPickup = !!r.pickup_requested_date || (!!id && !!sessionStorage.getItem('bp:pickup:' + id));
      } else if (r.boutique_hubspot_id) {
        hasStoreOrPickup = true;
      } else if (id && sessionStorage.getItem('bp:store:' + id)) {
        hasStoreOrPickup = true;
      }
    } catch (e) {
      /* sessionStorage indisponible */
    }

    var docsReceived;
    if (this.vendorType === 'NON_PART') {
      docsReceived = !!(docs.facture && docs.facture.status === 'received');
    } else {
      var cniReceived = docs.cni && docs.cni.status === 'received';
      var ribReceived = docs.rib && docs.rib.status === 'received';
      var contratReceived = docs.contrat_signe && docs.contrat_signe.status === 'received';
      docsReceived = !!(cniReceived && ribReceived && contratReceived);
    }

    if (docsReceived) return 'docs_uploaded';
    if (hasStoreOrPickup) return 'store_chosen';
    return 'none';
  };

  ContractualisationSubstep.SUBSTEPS = SUBSTEPS;
  window.ContractualisationSubstep = ContractualisationSubstep;
})(window);
